<template>
  <div>
    <div class="loading" v-if="!course || !course.name">
      <md-progress-spinner class="md-accent" :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div class="loading" v-if="course && course.name && errorMessage === null">
      <md-card>
        <md-card-header>
          <div class="md-title">
            <span v-if="!courseEdit">
              <span>{{course.name}}</span>
              <md-button class="md-icon-button md-dense md-primary" @click="editCourse(course)" v-bind:disabled="course.saving">
                <md-icon class="md-morph-final">edit</md-icon>
              </md-button>
            </span>
            <span v-if="courseEdit">
              <md-field>
                <md-input v-focus v-model="course.name" @keyup.enter="saveCourse(course)" @keyup.esc="cancelEditCourse(course)" maxlength="255"></md-input>
                <md-icon style="color: red;" v-if="isSoftLocked(course.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(course.versionedId.id)}}</md-tooltip>warning</md-icon>
                <span class="md-helper-text">{{course.oldObject.name}}</span>
              </md-field>
              <md-button class="md-icon-button md-dense md-primary" @click="saveCourse(course)" v-bind:disabled="course.saving">
                <md-icon class="md-morph-final">save</md-icon>
              </md-button>
              <md-button class="md-icon-button md-dense md-primary" @click="cancelEditCourse(course)">
                <md-icon class="md-morph-final">cancel</md-icon>
              </md-button>
              <md-button class="md-icon-button md-dense md-primary" @click="askToDeleteCourse(course)" v-bind:disabled="course.saving">
                <md-icon class="md-morph-final">delete</md-icon>
              </md-button>
            </span>

          </div>

        </md-card-header>

        <md-card-content>
          <!--<md-table v-if="course.activities && course.activities.length > 0">-->
          <md-table>

            <md-table-row>
              <md-table-head md-sort-name="name">Name</md-table-head>
              <md-table-head>Description</md-table-head>
              <md-table-head>Length</md-table-head>
              <md-table-head></md-table-head>
            </md-table-row>

            <!--<tr class="md-table-row" v-for="city in cities" :key="city.versionedId.id" v-on:click="editCity(city)">-->
            <md-table-row v-for="object in course.activities" :key="object.versionedId.id" >
              <md-table-cell>
                <span v-if="!object.edit">{{object.name}}</span>
                <span v-if="object.edit">
                  <md-field>
                    <md-input v-focus v-model="object.name" @keyup.enter="saveObject(object)" @keyup.esc="cancelEditObject(object)" maxlength="255"></md-input>
                    <md-icon style="color: red;" v-if="isSoftLocked(object.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                    <span class="md-helper-text">{{object.oldObject.name}}</span>
                  </md-field>
                </span>
              </md-table-cell>

              <md-table-cell>
                <span v-if="!object.edit">{{object.description}}</span>
                <span v-if="object.edit">
                  <md-field>
                    <md-input v-model="object.description" @keyup.enter="saveObject(object)" @keyup.esc="cancelEditObject(object)" maxlength="255"></md-input>
                    <md-icon style="color: red;" v-if="isSoftLocked(object.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                    <span class="md-helper-text">{{object.oldObject.description}}</span>
                  </md-field>
                </span>
              </md-table-cell>

              <md-table-cell>
                <span v-if="!object.edit">{{object.length}} min</span>
                <span v-if="object.edit">
                  <md-field>
                    <md-input v-model="object.length" @keyup.enter="saveObject(object)" @keyup.esc="cancelEditObject(object)" type="number"></md-input>
                    <md-icon style="color: red;" v-if="isSoftLocked(object.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                    <span class="md-helper-text">{{object.oldObject.length}}</span>
                  </md-field>
                </span>
              </md-table-cell>


              <md-table-cell>
                <md-button class="md-icon-button md-dense md-primary editButton" @click="editObject(object)" v-if="!object.edit"  v-bind:disabled="object.saving">
                  <md-icon class="md-morph-final">edit</md-icon>
                </md-button>
                <md-button class="md-icon-button md-dense md-primary" @click="saveObject(object)" v-if="object.edit" v-bind:disabled="object.saving">
                  <md-icon class="md-morph-final">save</md-icon>
                  <!--<md-tooltip md-delay="100">Save</md-tooltip>-->
                </md-button>
                <md-button class="md-icon-button md-dense md-primary" @click="cancelEditObject(object)" v-if="object.edit">
                  <md-icon class="md-morph-final">cancel</md-icon>
                  <!--<md-tooltip md-delay="100">Cancel</md-tooltip>-->
                </md-button>
                <md-button class="md-icon-button md-dense md-primary" @click="askToDelete(object)" v-if="object.edit" v-bind:disabled="object.saving">
                  <md-icon class="md-morph-final">delete</md-icon>
                  <!--<md-tooltip md-delay="100">Delete</md-tooltip>-->
                </md-button>
                <span>
                  <md-icon style="margin-top: 4px;" v-if="!object.edit && isSoftLocked(object.versionedId.id)" class="md-morph-final"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                </span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions>
          <md-button class="md-raised" :to="'../courses'" >Back to Courses</md-button>
          <md-button class="md-primary md-raised" @click="showNewObjectDialog">New Activity</md-button>
        </md-card-actions>
      </md-card>

    </div>

    <md-dialog :md-active.sync="createPromptActive">
      <md-dialog-title>Create a new activity</md-dialog-title>

      <div class="dialogContent">
        <md-field >
          <label>Name</label>
          <md-input v-focus ref="newObjectFirstField" v-model="newObject.name" @keyup.enter="createObject" @keyup.esc="createPromptActive = false" maxlength="255"></md-input>
        </md-field>

        <md-field>
          <label>Description</label>
          <md-input v-model="newObject.description" @keyup.enter="createObject" @keyup.esc="createPromptActive = false" maxlength="255"></md-input>
        </md-field>

        <md-field>
          <label>Length</label>
          <md-input v-model="newObject.length" @keyup.enter="createObject" @keyup.esc="createPromptActive = false" type="number"></md-input>
          <span class="md-helper-text">in minutes</span>
        </md-field>

        <md-dialog-actions>
          <md-button class="md-primary" @click="createPromptActive = false">Cancel</md-button>
          <md-button class="md-primary md-raised" @click="createObject" v-bind:disabled="!dialogCreateActive">Create</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="deletePromptActive"
      md-title="Delete activity"
      :md-content="'Are you sure you want to delete \'' + objectToDelete.name + '\'?'"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-confirm="confirmDelete" />

    <md-dialog-confirm
      :md-active.sync="courseDeletePromptActive"
      md-title="Delete course"
      :md-content="'Are you sure you want to delete the entire course \'' + objectToDelete.name + '\'?'"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-confirm="confirmDeleteCourse" />

    <md-snackbar md-position="center" :md-duration="8000" :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
      <md-button class="md-accent" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>

</template>

<script>
  var nameCompareIgnoreCase = function(a, b) {
    var nameA = a.name.toUpperCase(); // ignore upper and lowercase
    var nameB = b.name.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  };

  export default {
    name: "course-edit",
    data () {
      var mutableFields = ['name', 'description', 'length'];
      var newObject = {};
      mutableFields.forEach(fieldName => {
        newObject[fieldName] = '';
      });
      return {
        errorMessage: null,
        createPromptActive: false,
        deletePromptActive: false,
        objectToDelete: {},
        showSnackbar: false,
        snackbarMessage: '',
        newObject: newObject,
        courseDeletePromptActive: false,
        courseEdit: false,
        mutableFields: mutableFields,
        coursesSubscriptionId: null,
        courses: []
      }
    },
    computed: {
      course() {
        var selected = {
          name: this.$route.params.courseId
        };
        this.courses.forEach(course => {
            if (course.versionedId.id === this.$route.params.courseId) {
              selected = course;
              selected.activities.sort(nameCompareIgnoreCase);
            }
          }
        );

        return selected;
      },
      dialogCreateActive() {
        var active = true;
        this.mutableFields.forEach(fieldName => {
          if (this.newObject[fieldName].length < 1 && fieldName !== 'description') {
            active = false;
          }
        });
        return active;
      }
    },
    watch: {
      course: function(newCourse) {
        // this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
      }
    },
    methods: {
      isSoftLocked(lockId) {
        return (this.$store.state.otherUserPageLocks[lockId] !== undefined)
      },
      getLockedByString(lockId) {
        if (this.$store.state.otherUserPageLocks[lockId] !== undefined) {
          return Object.keys(this.$store.state.otherUserPageLocks[lockId]).join(', ');
        } else {
          return "";
        }
      },
      showNewObjectDialog() {
        this.mutableFields.forEach(fieldName => {
          this.newObject[fieldName] = '';
        });
        this.createPromptActive = true;
        var refs = this.$refs; setTimeout(() => this.$nextTick(() => refs.newObjectFirstField.$el.focus()), 300);
      },
      createObject() {
        this.createPromptActive = false;
        this.$store.api.rpcRequest('createCourseActivity', {
          name: this.newObject.name,
          courseId: this.course.versionedId.id,
          description: this.newObject.description,
          length: this.newObject.length
        }, newObject => {
        }, errorMessage => {
        });
      },
      editObject(object) {
        if (!object.edit) {
          var oldObject = Object.assign({}, object);
          object.oldObject = oldObject;
          object.edit = true;
          this.$store.api.softLock(this.$route.fullPath, object.versionedId.id);
        }
      },
      editCourse(object) {
        if (!this.courseEdit) {
          var oldObject = Object.assign({}, object);
          object.oldObject = oldObject;
          this.courseEdit = true;
          this.$store.api.softLock(this.$route.fullPath, object.versionedId.id);
        }
      },
      cancelEditCourse(object) {
        if (this.courseEdit) {
          object.name = object.oldObject.name;
          this.courseEdit = false;
          object.oldObject = {};
          this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
        }
      },
      cancelEditObject(object, fields = this.mutableFields) {
        if (object.edit) {
          fields.forEach(fieldName => {
            object[fieldName] = object.oldObject[fieldName];
          });
          object.edit = false;
          object.oldObject = {};
          this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
        }
      },
      saveObject(object) {
        if (object.edit) {
          this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
          object.edit = false;
          object.saving = true;
          this.$store.api.rpcRequest('saveCourseActivity', {
            versionedId: object.versionedId,
            name: object.name,
            description: object.description,
            length: object.length
          }, savedObject => {
            object.saving = false;
          }, errorMessage => {
            object.edit = true;
            object.saving = false;
            this.$store.api.softLock(this.$route.fullPath, object.versionedId.id);
          });
        }
      },
      saveCourse(object) {
        if (this.courseEdit) {
          this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
          this.courseEdit = false;
          object.saving = true;
          this.$store.api.rpcRequest('saveCourse', {
            versionedId: object.versionedId,
            name: object.name
          }, savedObject => {
            object.saving = false;
          }, errorMessage => {
            this.courseEdit = true;
            object.saving = false;
            this.$store.api.softLock(this.$route.fullPath, object.versionedId.id);
          });
        }
      },
      askToDelete(object) {
        this.objectToDelete = object;
        this.deletePromptActive = true;
      },
      confirmDelete() {
        this.deleteObject(this.objectToDelete);
      },
      deleteObject(object) {
        if (object.edit) {
          this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
          object.edit = false;
          object.saving = true;
          this.$store.api.rpcRequest('deletedCourseActivity', {
            versionedId: object.versionedId
          }, savedObject => {
            object.saving = false;
          }, errorMessage => {
            object.edit = true;
            object.saving = false;
            this.$store.api.softLock(this.$route.fullPath, object.versionedId.id);
          });
        }
      },
      askToDeleteCourse(object) {
        this.objectToDelete = object;
        this.courseDeletePromptActive = true;
      },
      confirmDeleteCourse() {
        this.deleteCourse(this.objectToDelete);
      },
      deleteCourse(object) {
        if (this.courseEdit) {
          this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
          this.courseEdit = false;
          object.saving = true;
          this.$store.api.rpcRequest('deleteCourse', {
            versionedId: object.versionedId
          }, savedObject => {
            object.saving = false;
            this.$router.push("../courses");
          }, errorMessage => {
            this.courseEdit = true;
            object.saving = false;
            this.$store.api.softLock(this.$route.fullPath, object.versionedId.id);
          });
        }
      },
      globalDetailsHandler(newGlobalDetails) {
        this.courses = newGlobalDetails.courses;
      }
    },
    created() {
      this.coursesSubscriptionId = this.$store.api.subscribe("GLOBAL_DETAILS", null, this.globalDetailsHandler);
    },
    beforeDestroy() {
      if (this.coursesSubscriptionId) {
        this.$store.api.unsubscribe(this.coursesSubscriptionId);
      }
      this.coursesSubscriptionId = null;
    }
  }
</script>

<style scoped>
  .dialogContent {
    padding: 24px;
  }

  .md-table-head {
    text-align: center;
  }

  button.editButton { visibility: hidden;}
  tr:hover button.editButton{ visibility: visible;}
</style>



// WEBPACK FOOTER //
// src/components/admin/GlobalCourseEdit.vue